import { combineEpics, createEpicMiddleware } from "redux-observable"
import "rxjs/add/observable/of"
import "rxjs/add/observable/fromPromise"
import "rxjs/add/observable/fromEvent"
import "rxjs/add/observable/from"
import "rxjs/add/operator/map"
import "rxjs/add/operator/catch"
import "rxjs/add/operator/mergeMap"
import "rxjs/add/operator/switchMap"
import "rxjs/add/operator/throttleTime"
import userEpics from "data/user/epics"
import searchEpics from "data/search/epics"

const rootEpic = combineEpics(...userEpics, ...searchEpics)

const epicMiddleware = createEpicMiddleware(rootEpic)

export default epicMiddleware



// WEBPACK FOOTER //
// ./src/global/store/epicMiddleware.js